import { render, staticRenderFns } from "./CargoExpenseKanbanEdit.vue?vue&type=template&id=513b5000"
import script from "./CargoExpenseKanbanEdit.vue?vue&type=script&lang=js"
export * from "./CargoExpenseKanbanEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports